var SceneTextComponent = (function () {
    function SceneTextComponent() {
    }
    SceneTextComponent.prototype.ngOnInit = function () {
    };
    SceneTextComponent.prototype.ngAfterViewInit = function () {
        $("#scene_text_wrap").animate({ opacity: 1 });
        // $("#scene_text_wrap").animate({marginTop:'0.3rem',opacity:1});
        $("#scene_text_wrap").html(this.content);
        $("#scene_text_wrap").find("img")[0].src = "../../assets/picture/casepractice/staff" + this.picture + ".png";
        // $("#scene_text_wrap").find("p").css("marginTop","0.25rem");
        //  $("#scene_text_wrap").find("p").first().css("marginTop","0");
    };
    return SceneTextComponent;
}());
export { SceneTextComponent };



// WEBPACK FOOTER //
// ./src/app/scene-text/scene-text.component.ts.pre-build-optimizer.js